<template>
  <div>
    <el-dialog
      v-if="!isMobile"
      :visible.sync="visible"
      width="560px"
      :before-close="handleClose"
    >
      <div class="content">
        <img src="../../assets/statics/changeIcon.png" />
        <div class="text">
          您当前的可用字数不足，<br />可以加入社群领取更多字数<br />或使用兑换码兑换更多字数
        </div>
      </div>
      <div class="buttonGroup">
        <el-button @click="joinClick" class="join">加入社群</el-button>
        <el-button @click="changeClick" class="change">兑换码兑换</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-else
      width="300px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <div class="mobileText">
        您当前的可用字数不足，<br />可以加入社群领取更多字数<br />或使用兑换码兑换更多字数
      </div>
      <div class="mobileButtonGroup">
        <el-button @click="changeClick" class="change">点击前往</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="!isMobile"
      :visible.sync="openChangeVisible"
      width="560px"
      :before-close="closeOpenChange"
    >
      <div class="changeDialog">
        <div class="title">请输入兑换码，兑换字数权益</div>
        <div class="form">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item>
              <el-input v-model="form.code" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                :disabled="form.code === ''"
                @click="onSubmit"
                >兑换</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="toast" v-show="changeSuccess">
          <i class="el-icon-success" />兑换成功
        </div>
        <div class="tip">* 每一个兑换码仅有一次使用机会</div>
        <div class="joinTip">加入社群获取更多权益</div>
        <img class="image" src="../../assets/statics/images/group.png" />
      </div>
    </el-dialog>
    <el-dialog
      v-else
      :visible.sync="openChangeVisible"
      :before-close="closeOpenChange"
      width="300px"
    >
      <div class="mobileTitle" slot="title">兑换字数</div>
      <div class="mobileChangeDialog">
        <div class="form">
          <el-form :model="form" class="demo-form-inline">
            <el-form-item>
              <el-input
                v-model="form.code"
                placeholder="请输入兑换码，兑换字数权益"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tip">* 每一个兑换码仅有一次使用机会</div>
        <el-button
          class="button"
          type="primary"
          :disabled="form.code === ''"
          @click="onSubmit"
        >
          兑换
        </el-button>
        <img class="image" src="../../assets/statics/images/group.png" />
        <div class="joinTip">加入社群获取更多权益</div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="openJoin" width="560px">
      <div class="joinDialog">
        <div class="title">加入官方社群</div>
        <img class="image" src="../../assets/statics/images/group.png" />
        <div class="text">获取产品最新信息，解锁更多福利</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../../http/api";

export default {
  data() {
    return {
      isMobile: false,
      openJoin: false,
      openChange: false,
      changeSuccess: false,
      form: { code: "" },
    };
  },
  computed: {
    openChangeVisible() {
      return this.$store.state.changeOpen || this.openChange;
    },
  },
  created() {
    this.isMobile = window.navigator.userAgent.includes("Mobile");
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
      default: null,
    },
  },
  methods: {
    handleClose() {
      this.close();
    },
    changeClick() {
      this.openChange = true;
    },
    joinClick() {
      this.openJoin = true;
    },
    closeOpenChange() {
      this.openChange = false;
      this.form.code = "";
      this.changeSuccess = false;
      this.$store.dispatch("setChangeOpen", false);
    },
    async onSubmit() {
      const res = await Api.Chat.changeForCount({ code: this.form.code });

      if (res.error) {
        return this.$message.error("兑换失败");
      }

      this.$store.dispatch("setCount");
      this.changeSuccess = true;
      if (this.isMobile) {
        this.$message.success("兑换成功！");
        this.$store.dispatch("setChangeOpen", false);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: row;
  padding: 0 96px;
  font-size: 20px;
  font-weight: 400;
  color: #111b3a;
  align-items: center;

  .text {
    flex: 1;
    margin-left: 28px;
  }
}
.buttonGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  .join,
  .change {
    font-size: 18px;
    font-weight: 500;
    color: #111b3a;
    border-radius: 8px;
  }
}

.title {
  font-size: 25px;
  font-weight: 400;
  color: #111b3a;
}

.joinDialog {
  display: flex;
  flex-direction: column;
  align-items: center;

  .image {
    width: 180px;
    height: 180px;
    margin: 36px 0;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #3f3f3f;
  }
}

.changeDialog {
  display: flex;
  flex-direction: column;
  align-items: center;

  .form {
    margin-top: 16px;
  }
  .toast {
    margin-bottom: 8px;
    font-size: 17px;
    font-weight: 500;
    color: #111b3a;
  }
  .tip {
    font-size: 14px;
    font-weight: 400;
    color: #3f3f3f;
  }

  .joinTip {
    margin-top: 36px;
    font-size: 16px;
  }

  .image {
    width: 180px;
    height: 180px;
    margin: 16px 0;
  }
}

.mobileChangeDialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  .form {
    width: 100%;
    max-width: 300px;
    margin-top: 16px;
  }

  .tip {
    font-size: 14px;
    font-weight: 400;
    color: #3f3f3f;
  }
  .image {
    width: 114px;
    height: 114px;
    margin-top: 24px;
  }
  .joinTip {
    color: rgba(17, 29, 58, 0.5);
  }
  .button {
    margin-top: 14px;
    border-radius: 1.5rem;
    height: 3rem;
    width: 150px;
    background: linear-gradient(150deg, #7ba0ff, #ee74ff);
    color: #ffffff;
  }
}
.mobileTitle {
  color: #111d3a;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}

.mobileText {
  font-size: 14px;
  color: #111d3a;
  text-align: center;
  margin-top: 20px;
}
.mobileButtonGroup {
  text-align: center;

  .change {
    background: linear-gradient(150deg, #7ba0ff, #ee74ff);
    color: #ffffff;
    margin-top: 24px;
    border-radius: 1.5rem;
    height: 3rem;
    width: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/industryChat/ChangeWordsEntry.vue